/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BatchUpdateGoodsStatusReqVo
 */
export interface BatchUpdateGoodsStatusReqVo {
    /**
     * 商品ID列表
     * @type {Array<number>}
     * @memberof BatchUpdateGoodsStatusReqVo
     */
    goodsIds?: Array<number>;
    /**
     * 商品状态
     * @type {number}
     * @memberof BatchUpdateGoodsStatusReqVo
     */
    goodsStatus?: number;
}

/**
 * Check if a given object implements the BatchUpdateGoodsStatusReqVo interface.
 */
export function instanceOfBatchUpdateGoodsStatusReqVo(value: object): value is BatchUpdateGoodsStatusReqVo {
    return true;
}

export function BatchUpdateGoodsStatusReqVoFromJSON(json: any): BatchUpdateGoodsStatusReqVo {
    return BatchUpdateGoodsStatusReqVoFromJSONTyped(json, false);
}

export function BatchUpdateGoodsStatusReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchUpdateGoodsStatusReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'goodsIds': json['goodsIds'] == null ? undefined : json['goodsIds'],
        'goodsStatus': json['goodsStatus'] == null ? undefined : json['goodsStatus'],
    };
}

export function BatchUpdateGoodsStatusReqVoToJSON(json: any): BatchUpdateGoodsStatusReqVo {
    return BatchUpdateGoodsStatusReqVoToJSONTyped(json, false);
}

export function BatchUpdateGoodsStatusReqVoToJSONTyped(value?: BatchUpdateGoodsStatusReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'goodsIds': value['goodsIds'],
        'goodsStatus': value['goodsStatus'],
    };
}

